import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useGallery() {
  const [data, setData] = useState({ items: [], event_image_url: "" });
  useEffect(() => {
    api.get("/gallery").then((r) => setData(r.data)).catch(() => {});
  }, []);
  return data;
}
